<template>
  <span>
    <a href="#" @click="show = true" v-b-tooltip.hover>
      <span v-if="creator">
        <MessageStatus v-if="info.status" :status="info.status"></MessageStatus>
        <span v-if="!info.status" :title='showStatus'><i v-if="getStatus == 0" class="fal fa-envelope"></i>
        <i v-if="getStatus == 1" class="fal fa-envelope-open"></i>
        <i v-if="getStatus == 2" class="fal fa-ban"></i>
        <i v-if="getStatus == 3" class="fal fa-comment"></i>
        <i v-if="getStatus == 10" class="fal fa-exclamation-circle red"></i></span>
      </span>
      {{ info.email }}<span v-if="!islast">;&nbsp;&nbsp;</span></a
    >
    <b-sidebar
      id="message-participant"
      v-model="show"
      right
      no-slide
      shadow
      backdrop
    >
      <div class="px-3 py-2">

        <UserInfo
            class="mt-4"
            image="/img/default-avatar.png"
            :primary="info.email"
          ></UserInfo>

          
          <hr class="pb-0 mb-0 mt-2" />

        <dl class="clearfix mt-2">
            <dt>{{ $t('STATUS') }}</dt>
            <dd>  
              <MessageStatus v-if="info.status" :status="info.status" show-text></MessageStatus>
              <span v-if="!info.status">
                <i v-if="getStatus == 0" class="fal fa-envelope"></i>
                <i v-if="getStatus == 1" class="fal fa-envelope-open"></i>
                <i v-if="getStatus == 2" class="fal fa-ban"></i>
                <i v-if="getStatus == 3" class="fal fa-comment"></i>
                <i v-if="getStatus == 10" class="fal fa-exclamation-circle red"></i>
                {{ showStatus }}
              </span>
            </dd>
            <dt v-if="info.fetched">{{ $t('VIEWED') }}</dt>
            <dd v-if="info.fetched">{{ FormatDateTime(info.fetched_date) }}</dd>
            <dt v-if="info.recalled">{{ $t('RECALLED') }}</dt>
            <dd v-if="info.recalled">{{ FormatDateTime(info.recalled_date) }}</dd>
            <dt v-if="responsed">{{ $t('RESPONSED') }}</dt>
            <dd v-if="responsed">{{ FormatDateTime(info.response_date) }}</dd>
        </dl>

        <RespondedMessage class="mt-2" :functionbox_uuid="functionbox_uuid" v-if="showResponse" :message_uuid="info.response_message_uuid"></RespondedMessage>

          <hr class="pb-0 mb-0 mt-2" />
          
        <b-button v-if="info.response_message_uuid != '' && showResponse == false"
          variant="primary"
          size="sm"
          class="btn-fill mt-2"
          @click="viewResponse"
          >{{ $t("SHOW_RESPONSE") }}</b-button
        >

        <b-button v-if="getStatus == 0"
          size="sm"
          variant="danger"
          class="btn-fill mt-2"
          @click="recall"
          >{{ $t("RECALL") }}</b-button
        >
        
          <b-button
            v-if="getStatus == 10"
            variant="primary"
            size="sm"
            class="btn-fill mt-2"
            @click="resend"
            >{{ $t("RESEND") }}</b-button
          >

      </div>
    </b-sidebar>
  </span>
</template>
<script>
import UserInfo from "@/components/Layout/UserInfo";
import MessageStatus from "@/components/View/MessageStatus";
import RespondedMessage from "@/components/View/RespondedMessage";
export default {
  components: { UserInfo, RespondedMessage, MessageStatus },
  props: ["response","index", "item", "islast", "creator", "status","functionbox_uuid"],
  data() {
    return {
      show: false,
      info: this.item,
      showDialog: false,
      viewed: false,
      viewed_date: "",
      showResponse: false
    };
  },
  methods: {    
    viewResponse: function() {
      this.showResponse = true;
    },
    onShow: function() {
      this.$root.$emit("bv::hide::popover");
    },
    onClose: function() {
      this.showDialog = false;
    },   
    recall: function() {
      let self = this;   
      this.$bvModal.msgBoxConfirm(this.$t('ARE_YOU_SURE'), {
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        dialogClass: this.teams.theme,
        okTitle: this.$t('YES'),
        cancelTitle: this.$t('NO'),
        bodyClass: 'messagebox',
        footerClass: 'p-2  text-center messagebox',
        hideHeaderClose: false,
        centered: true
      })
      .then(function(value){
        if(value)
        {          
           self.$http
              .post(self.user.hostname + "/message/user/recall", {
                  participant_id: self.info.id
                })
              .then(
                function(response) {
                  self.info.recalled = 1;
                  self.info.recalled_date = response.data.recalled_date;
                  self.$noty.info(self.$t("UPDATED"));
                }
              )
              .catch(function(error) {
                self.loading = false;
                if(error.toString() == "Error: fail_4_4") return;
                if (error.response != undefined) {
                  self.$noty.error(self.$t(error.response.data));
                }
              });
        }
      })
      .catch(function(){
      }); 
    },
    resend: function() {
      let self = this;   
      this.$bvModal.msgBoxConfirm(this.$t('ARE_YOU_SURE'), {
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: this.$t('YES'),
        dialogClass: this.teams.theme,
        cancelTitle: this.$t('NO'),
        bodyClass: 'messagebox',
        footerClass: 'p-2  text-center messagebox',
        hideHeaderClose: false,
        centered: true
      })
      .then(function(value){
        if(value)
        {          
          self.loading = true;
          self.$http
            .post(
              self.user.hostname + "/message/resend",
              {
                participant_id: self.info.id,
              }
            )
            .then(function() {
              self.loading = false;
              if(self.info.sent != undefined)
              {
                self.info.sent = 1;
              }
              self.$noty.info(self.$t("UPDATED"));
            })
            .catch(function(error) {
              self.loading = false;
              if(error.toString() == "Error: fail_4_4") return;
              if (error.response != undefined) {
                self.$noty.error(self.$t(error.response.data));
              }
            });
        }
      })
      .catch(function(){
      }); 
    }
  },
  computed: {
    teams() {
      return this.$store.state.teams;
    },
    responsed () {
      return this.info.response_message_uuid != "";
    }, 
    getStatus() {
      if(this.responsed)
      {
        return 3;
      }
      if(this.info.recalled == 1)
      {
        return 2;
      }
      if(this.info.fetched == 1)
      {
        return 1;
      }
      if(this.info.sent != undefined)
      {
        if (this.info.sent == 0) {
          return 10;
        }
      }
      return 0;
    },
    popoverTarget() {
      return "Participant" + this.index;
    },
    showStatus() {
      if(this.responsed)
      {
        return this.$t("RESPONSED");
      }
      if(this.info.recalled == 1)
      {
        return this.$t("RECALLED");
      }
      if(this.info.fetched == 1)
      {
        return this.$t("VIEWED");
      }
      if(this.info.sent != undefined)
      {
        if (this.info.sent == 0) {
          return this.$t("NOT_SENT");
        }
      }
      return this.$t("NOT_VIEWED");
    }
  },
};
</script>
<style></style>
